// removed by extract-text-webpack-plugin
module.exports = {"Base":"ColdBrew__Base-jMjrB","Article":"ColdBrew__Article-2-fWf","Figure":"ColdBrew__Figure-2bbQe","Image":"ColdBrew__Image-21Hua","FigCaption":"ColdBrew__FigCaption-3qW6f","Base--horizontal":"ColdBrew__Base--horizontal-1sIuT","ContentArea":"ColdBrew__ContentArea-2wMTb","Header":"ColdBrew__Header-1VN9w","Title":"ColdBrew__Title-6Jorm","Title--underlined":"ColdBrew__Title--underlined-2NdvF ColdBrew__Title-6Jorm","Content":"ColdBrew__Content-1zb2d"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ColdBrew/ColdBrew.css
 ** module id = 625
 ** module chunks = 0
 **/